// Simple authentication utilities
// Generate a random token for magic link
export const generateMagicToken = (): string => {
  return (
    Math.random().toString(36).substring(2, 15) +
    Math.random().toString(36).substring(2, 15)
  )
}
// Store token in localStorage with email and expiry
export const storeMagicToken = (email: string, token: string): void => {
  const expiryTime = Date.now() + 15 * 60 * 1000 // 15 minutes from now
  localStorage.setItem(
    'magicLinkData',
    JSON.stringify({
      email,
      token,
      expiry: expiryTime,
    }),
  )
}
// Verify a magic token against stored one
export const verifyMagicToken = (token: string): boolean => {
  const storedData = localStorage.getItem('magicLinkData')
  if (!storedData) return false
  const { token: storedToken, expiry } = JSON.parse(storedData)
  // Check if token matches and hasn't expired
  if (token === storedToken && Date.now() < expiry) {
    // Set user as logged in
    const { email } = JSON.parse(storedData)
    localStorage.setItem(
      'currentUser',
      JSON.stringify({ email, role: 'manager' }),
    )
    // Clean up the magic link data
    localStorage.removeItem('magicLinkData')
    return true
  }
  return false
}
// Check if user is logged in
export const isLoggedIn = (): boolean => {
  const userData = localStorage.getItem('currentUser')
  return !!userData
}
// Get current user data
export const getCurrentUser = (): { email: string; role: string } | null => {
  const userData = localStorage.getItem('currentUser')
  if (!userData) return null
  return JSON.parse(userData)
}
// Log out user
export const logoutUser = (): void => {
  localStorage.removeItem('currentUser')
}
